import { useCallback, useRef, useState } from "react";

export const useContainerWidth = () => {
  const [width, setWidth] = useState<number>(0);
  const observerRef = useRef<ResizeObserver | null>(null);

  const containerRef = useCallback((node: HTMLDivElement | null) => {
    if (observerRef.current) {
      observerRef.current.disconnect();
      observerRef.current = null;
    }

    if (!node) return;

    setWidth(node.getBoundingClientRect().width);

    const observer = new ResizeObserver(entries => {
      const entry = entries[0];
      if (entry?.contentRect) {
        setWidth(entry.contentRect.width);
      }
    });
    observer.observe(node);
    observerRef.current = observer;
  }, []);

  return { containerRef, width };
};
